const baseUrl = 'https://awspapi.pitsco.com/dev/shop/v1/Shopify/';
const apiKey = 'test';

/** 
 * @typedef {Object} SafetyDataSheetSearchResult 
 * @property {string} code - The code of the product.
 * @property {string} name - The name of the product.
 * @property {string} keywords - The URL of the product.
 */


/**
 * @typedef {Object} SafetyDataSheetDownload
 * @property {string} name - The name of the PDF.
 * @property {string} url - The URL of the PDF.
 * @property {string} skUname - The product name.
 */

/**
 * @typedef {Object} API
 * @property {function(string): Promise<SafetyDataSheetSearchResult[]>} searchSafetyDataSheets - A function that searches for safety data sheets based on a query string
 * @property {function(string): Promise<SafetyDataSheetDownload[]>} getSafetyDataSheets - A function that fetches safety data sheets based on a query string
 */

const api = {
    searchSafetyDataSheets: async (query) => {
        const queryParams = new URLSearchParams({ q: query });
        const url = window.Shopify.routes.root + `apps/sds/app/search?${queryParams.toString()}`

        const response = await fetch(url);

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Failed to fetch safety data sheets');
        }
    },

    getSafetyDataSheets: async (productNumber) => {
        const queryParams = new URLSearchParams({ productNumber: productNumber });
        const url = window.Shopify.routes.root + `apps/sds/app/sheets?${queryParams.toString()}`

        const response = await fetch(url);

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Failed to fetch safety data sheets');
        }
    }
};

/** @type {API} */
window.api = api;